import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { AiFillLike, AiFillDislike } from "react-icons/ai";

// Components
import Typography from '../Typography';
import Modal from '../modal';
import Button from '../CustomButton';

// Styles
import styles from './style.module.scss';

// Assets
import Avatar from '../../components/assets/mascot/mascot1.png'

interface FeedbackModalProps {
  open: boolean;
  onLike: () => void;
  onDislike: () => void;
  onClose: () => void;
  message?: string;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ open, onClose, onLike, onDislike, message }) => {
  const { t } = useTranslation();
  const _message = message || t('feedbackModal.message');

  return (
    <Modal
      open={open}
      title=''
      onClose={onClose}
      showCloseButton
      footer={
        <div className={styles.footer}>
          <div className={styles.buttons}>
            <Button
              variant="text"
              classes={{ root: styles.button_feedback }}
              onClick={onLike}
            >
              <AiFillLike />
            </Button>
            <Button
              variant="text"
              classes={{ root: styles.button_feedback }}
              onClick={onDislike}
            >
              <AiFillDislike />
            </Button>
          </div>

          <Button
            variant="text"
            onClick={onClose}
            classes={{ root: styles.button_close }}
          >
            {t('actions.skip')}
          </Button>
        </div>
      }
    >
      <div className={styles.content}>
        <img src={Avatar} alt="mascot" className={styles.avatar} />

        <Typography variant="p" className={styles.message}>
          {_message}
        </Typography>
      </div>
    </Modal>
  )
}

export default FeedbackModal;
